























import { Vue, Component, Prop } from "vue-property-decorator";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";
import * as images from "../../assets/images";
import { DocConsenso } from "../../_models/docConsenso";
import { bus } from "../../main";
import axios from "axios";

//@ts-ignore
import * as pdfMake from "pdfmake/build/pdfmake";
//@ts-ignore
import * as pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component
export default class ConsensoReview extends Vue {
  @Prop() docInfo!: DocConsenso;
  private ruoloUtente: number[];
  private tipoAttivita: string;

  private elements: DocConsenso;

  private doc: any;

  constructor() {
    super();
    this.ruoloUtente = [];
    this.tipoAttivita = "";
    this.elements = {
      idConsenso: this.docInfo.idConsenso,
      tirocinante: this.docInfo.tirocinante,
      indirizzoTirocinante: this.docInfo.indirizzoTirocinante,
      comuneTirocinante: this.docInfo.comuneTirocinante,
      denominazioneAzienda: this.docInfo.denominazioneAzienda,
      indirizzoAzienda: this.docInfo.indirizzoAzienda,
      comuneAzienda: this.docInfo.comuneAzienda,
      pIvaAzienda: this.docInfo.pIvaAzienda,
      rappresentanteAzienda: this.docInfo.rappresentanteAzienda,
      dataDocumento: this.docInfo.dataDocumento,
      idStatoDoc: this.docInfo.idStatoDoc,
      firmaAzienda: this.docInfo.firmaAzienda,
      firmaTirocinante: this.docInfo.firmaTirocinante,
      firmaIstituto: this.docInfo.firmaIstituto,
      tipoAttivita: this.docInfo.tipoAttivita,
      numeroProtocollo: this.docInfo.numeroProtocollo,
      idTemplate: this.docInfo.idTemplate
    };
    this.doc = null;
  }

  createDoc() {
    if (this.elements.firmaAzienda === null) {
      this.elements.firmaAzienda = images.noFirma;
    }
    if (this.elements.firmaTirocinante === null) {
      this.elements.firmaTirocinante = images.noFirma;
    }

    var dd = {
      /**--------------------------------------------------------
         * Le immagini di header e footer sono convertite in Base64
         * ed importate dal file Header_Footer.js
         ----------------------------------------------------------*/
      pageSize: "A4",
      // ****** FOOTER *********//
      footer: function(/*currentPage, pageCount*/) {
        return [
          {
            image: images.authFooter,
            width: "560",
            height: "80",
            margin: [20, 0]
          }
        ];
      },
      // // ******** HEADER ******** //
      header: function(/*currentPage, pageCount, pageSize*/) {
        // you can apply any logic and return any valid pdfmake element

        return [
          {
            // image: images.authHeader,
            image: images.authHeader,
            width: "525",
            height: "90",
            margin: [35, 0]
          }
        ];
      },

      //******** TESTO DEL DOCUMENTO  ********/
      content: [
        {
          text: "DICHIARAZIONE DI CONSENSO",
          alignment: "center",
          margin: [0, 70, 0, 0],
          bold: true,
          fontSize: 10
        },
        {
          text: "all'attivazione di un " + this.tipoAttivita,
          alignment: "center",
          bold: true,
          fontSize: 10
        },
        {
          text: "ai sensi del DPGR Piemonte del 22/05/2020, art. 27",
          alignment: "center",
          bold: true,
          margin: [0, 0, 0, 10],
          fontSize: 10
        },
        {
          text: "I sottoscritti:",
          style: "bodyText",
          margin: [0, 0, 0, 5]
        },
        {
          ul: [
            {
              text:
                "Paolo CORTESE in qualità di Dirigente Scolastico dell’I.I.S. “G. VALLAURI” , codice fiscale 83003390040 con sede in Fossano, Via San Michele 68 - soggetto PROMOTORE,",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                this.elements.rappresentanteAzienda +
                " in qualità di legale rappresentante dell’azienda " +
                this.elements.denominazioneAzienda +
                ", P. IVA " +
                this.elements.pIvaAzienda +
                " con sede in " +
                this.elements.comuneAzienda +
                ", " +
                this.elements.indirizzoAzienda +
                " - soggetto OSPITANTE,",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                this.elements.tirocinante +
                " in qualità di tirocinante residente in " +
                this.elements.indirizzoTirocinante +
                ", " +
                this.elements.comuneTirocinante +
                " - TIROCINANTE",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            }
          ]
        },
        {
          text:
            "dichiarano il proprio consenso alla realizzazione di un tirocinio extracurriculare estivo, ai sensi delle normative regionale.",
          bold: true,
          style: "bodyText",
          margin: [0, 0, 0, 5]
        },
        {
          text: "L’inizio dell’attività di tirocinio è subordinata:",
          style: "bodyText",
          margin: [0, 0, 0, 5]
        },
        {
          ul: [
            {
              text:
                "al consenso di tutti gli interessati (TIROCINANTE / SOGGETTO PROMOTORE / SOGGETTO OSPITANTE), raccolto dal soggetto promotore (IIS “G. Vallauri”).",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "alla messa in atto e all’osservanza, da parte del soggetto ospitante, di tutte le disposizioni relative alle misure organizzative di prevenzione e di protezione citate nei decreti normativi.",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            }
          ]
        },
        {
          text:
            "Attraverso la sottoscrizione del presente consenso il SOGGETTO OSPITANTE dichiara di aver provveduto a metter in atto TUTTE le disposizioni relative alle misure organizzative di prevenzione e di protezione citate nei decreti normativi prima dell’INIZIO del tirocinio.",
          style: "bodyText",
          margin: [0, 0, 0, 5]
        },
        {
          text: "Fossano, " + this.elements.dataDocumento,
          style: "bodyText",
          margin: [0, 0, 0, 10]
        },
        {
          text: "IL SOGGETTO PROMOTORE",
          style: "bodyText",
          alignment: "right",
          margin: [0, 0, 0, 10]
        },
        {
          image: images.firmaVallauri,
          width: 180,
          alignment: "right"
        },
        {
          text: "IL SOGGETTO OSPITANTE",
          style: "bodyText",
          alignment: "right",
          margin: [0, 10, 0, 10]
        },
        {
          image: this.elements.firmaAzienda,
          width: 180,
          alignment: "right"
        },
        {
          text: "IL TIROCINANTE",
          style: "bodyText",
          alignment: "right",
          margin: [0, 10, 0, 10]
        },
        {
          image: this.elements.firmaTirocinante,
          width: 180,
          alignment: "right"
        }
      ],
      styles: {
        bodyText: {
          fontSize: 10,
          justified: true
        },
        tableTitle: {
          fontSize: 10,
          bold: "true",
          alignment: "right"
        },
        tableText: {
          fontSize: 8
        },
        tableTextHigh: {
          fontSize: 8,
          background: "yellow"
        }
      }
    };
    var finalDocStr: string = this.completeDoc();
    var json = JSON.parse(finalDocStr);

    const pdfDocGenerator = pdfMake.createPdf(json);
    // const pdfDocGenerator = pdfMake.createPdf(dd);
    // console.log(dd)
    pdfDocGenerator.getDataUrl(function(dataUrl: any) {
      const targetElement = document.querySelector("#iframeContainer");
      const embed = document.createElement("embed");
      embed.src = dataUrl;
      embed.width = "1000";
      embed.height = "700";
      if (targetElement !== null) {
        targetElement.appendChild(embed);
      }
    });
  }

  completeDoc(): string {
    var completeDoc: string = "";
    completeDoc = JSON.stringify(this.doc);
    //console.log(completeDoc)
    // var finalStr = this.docTest.replace(/%%_tirocinante_%%/g, '"' + this.elements.tirocinante + '"')
    completeDoc = completeDoc.replace(/%%_header_%%/g, images.authHeader);
    completeDoc = completeDoc.replace(/%%_footer_%%/g, images.authFooter);
    completeDoc = completeDoc.replace(/%%_headerDocVallauri_%%/g, images.headerDocVallauri);
    completeDoc = completeDoc.replace(/%%_footerDocVallauri_%%/g, images.footerDocVallauri);
    completeDoc = completeDoc.replace(
      /%%_tirocinante_%%/g,
      this.elements.tirocinante
    );
    completeDoc = completeDoc.replace(
      /%%_indirizzoTirocinante_%%/g,
      this.elements.indirizzoTirocinante
    );
    completeDoc = completeDoc.replace(
      /%%_comuneTirocinante_%%/g,
      this.elements.comuneTirocinante
    );
    completeDoc = completeDoc.replace(
      /%%_denominazioneAzienda_%%/g,
      this.elements.denominazioneAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_indirizzoAzienda_%%/g,
      this.elements.indirizzoAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_comuneAzienda_%%/g,
      this.elements.comuneAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_pIvaAzienda_%%/g,
      this.elements.pIvaAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_rappresentanteAzienda_%%/g,
      this.elements.rappresentanteAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_dataDocumento_%%/g,
      this.elements.dataDocumento
    );
    completeDoc = completeDoc.replace(
      /%%_firmaAzienda_%%/g,
      this.elements.firmaAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_firmaTirocinante_%%/g,
      this.elements.firmaTirocinante
    );
    completeDoc = completeDoc.replace(
      /%%_firmaIstituto_%%/g,
      this.elements.firmaIstituto
    );
    completeDoc = completeDoc.replace(/%%_tipoAttivita_%%/g, this.tipoAttivita);
    completeDoc = completeDoc.replace(
      /%%_numeroProtocollo_%%/g,
      this.elements.numeroProtocollo
    );
    return completeDoc;
  }

  confirm() {
    var payload = {
      idConsenso: this.elements.idConsenso
    };
    if (this.elements.firmaAzienda !== null) {
      user
        .dispatchConfirmConsenso(this["$store"], payload)
        .then(() => {
          this.close();
          bus.$emit("loadPreAssegnazioni");
          bus.$emit(
            "successfullOperation",
            "Dichiarazione Consenso accettata con successo"
          );
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", error.response.statusText);
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", error.response.statusText);
          }
        });
    } else {
      bus.$emit(
        "errorOperation",
        "Impossibile accettare documento. Firma Azienda mancante"
      );
    }
  }
  refuse() {
    var payload = {
      idConsenso: this.elements.idConsenso
    };
    if (this.elements.firmaAzienda !== null) {
      user
        .dispatchRefuseConsenso(this["$store"], payload)
        .then(() => {
          this.close();
          bus.$emit("loadPreAssegnazioni");
          bus.$emit(
            "successfullOperation",
            "Dichiarazione Consenso rifiutata con successo"
          );
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", error.response.statusText);
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", error.response.statusText);
          }
        });
    } else {
      bus.$emit(
        "errorOperation",
        "Impossibile accettare documento. Firma Azienda mancante"
      );
    }
  }

  close() {
    bus.$emit("closeReview");
  }

  created() {
    // if (this.docInfo.tipoAttivita === "tirocinioReIns") {
    //   this.tipoAttivita = "tirocinio di inserimento/reinserimento";
    // } else if (this.docInfo.tipoAttivita === "tirocinioFormativo") {
    //   this.tipoAttivita = "tirocinio formativo e di orientamento";
    // }
    // var userInfo = user.readUserInfo(this["$store"]);
    // if (userInfo === null) {
    //   userInfo = user.readStudentInfo(this["$store"]);
    // }
    // this.ruoloUtente = userInfo.ruoloUtente;
    // this.createDoc();

    data
      .dispatchTemplateDoc(this["$store"], this.docInfo.idTemplate)
      .then(result => {
        this.doc = result;
        if (this.docInfo.tipoAttivita === "tirocinioReIns") {
          this.tipoAttivita = "tirocinio di inserimento/reinserimento";
        } else if (this.docInfo.tipoAttivita === "tirocinioFormativo") {
          this.tipoAttivita = "tirocinio formativo e di orientamento";
        }
        var userInfo = user.readUserInfo(this["$store"]);
        if (userInfo === null) {
          userInfo = user.readStudentInfo(this["$store"]);
        }
        this.ruoloUtente = userInfo.ruoloUtente;
        this.createDoc();
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });

    // axios.get("http://localhost:8181/test").then(result => {
    // this.docTest = result.data;

    // });
  }
}
